export function setStorageValue<T>(key: string, value: T) {
  try {
    localStorage.setItem(
      key,
      typeof value !== 'string' ? JSON.stringify(value) : value
    );
  } catch {
    // storage can be disabled or full, and a lost preference must not take
    // down whatever rendered the hook
  }
}
